/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface AdOverview
 */
export interface AdOverview {
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdOverview
     */
    cpa?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdOverview
     */
    cpm?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdOverview
     */
    cpc?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    pnoNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    pnoGross?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    roasNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    roasGross?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    poasNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    poasGross?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    ctr?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    conversionRateNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    conversionRateGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdOverview
     */
    profitNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdOverview
     */
    profitGross?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    profitPercentNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    profitPercentGross?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    unverifiedLeads?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    verifiedLeads?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    ordersNet?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    ordersGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdOverview
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdOverview
     */
    turnoverGross?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdOverview
     */
    spendGoodsNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdOverview
     */
    spendGoodsGross?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdOverview
     */
    spendMarketing?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof AdOverview
     */
    impressions?: number;
    /**
     * 
     * @type {string}
     * @memberof AdOverview
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdOverview
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdOverview
     */
    statusName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdOverview
     */
    status?: string;
}

/**
 * Check if a given object implements the AdOverview interface.
 */
export function instanceOfAdOverview(value: object): value is AdOverview {
    return true;
}

export function AdOverviewFromJSON(json: any): AdOverview {
    return AdOverviewFromJSONTyped(json, false);
}

export function AdOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'cpa': json['cpa'] == null ? undefined : MoneyOutputFromJSON(json['cpa']),
        'cpm': json['cpm'] == null ? undefined : MoneyOutputFromJSON(json['cpm']),
        'cpc': json['cpc'] == null ? undefined : MoneyOutputFromJSON(json['cpc']),
        'pnoNet': json['pnoNet'] == null ? undefined : json['pnoNet'],
        'pnoGross': json['pnoGross'] == null ? undefined : json['pnoGross'],
        'roasNet': json['roasNet'] == null ? undefined : json['roasNet'],
        'roasGross': json['roasGross'] == null ? undefined : json['roasGross'],
        'poasNet': json['poasNet'] == null ? undefined : json['poasNet'],
        'poasGross': json['poasGross'] == null ? undefined : json['poasGross'],
        'ctr': json['ctr'] == null ? undefined : json['ctr'],
        'conversionRateNet': json['conversionRateNet'] == null ? undefined : json['conversionRateNet'],
        'conversionRateGross': json['conversionRateGross'] == null ? undefined : json['conversionRateGross'],
        'profitNet': json['profitNet'] == null ? undefined : MoneyOutputFromJSON(json['profitNet']),
        'profitGross': json['profitGross'] == null ? undefined : MoneyOutputFromJSON(json['profitGross']),
        'profitPercentNet': json['profitPercentNet'] == null ? undefined : json['profitPercentNet'],
        'profitPercentGross': json['profitPercentGross'] == null ? undefined : json['profitPercentGross'],
        'unverifiedLeads': json['unverifiedLeads'] == null ? undefined : json['unverifiedLeads'],
        'verifiedLeads': json['verifiedLeads'] == null ? undefined : json['verifiedLeads'],
        'ordersNet': json['ordersNet'] == null ? undefined : json['ordersNet'],
        'ordersGross': json['ordersGross'] == null ? undefined : json['ordersGross'],
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
        'spendGoodsNet': json['spendGoodsNet'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsNet']),
        'spendGoodsGross': json['spendGoodsGross'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsGross']),
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyOutputFromJSON(json['spendMarketing']),
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'statusName': json['statusName'] == null ? undefined : json['statusName'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function AdOverviewToJSON(json: any): AdOverview {
    return AdOverviewToJSONTyped(json, false);
}

export function AdOverviewToJSONTyped(value?: AdOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cpa': MoneyOutputToJSON(value['cpa']),
        'cpm': MoneyOutputToJSON(value['cpm']),
        'cpc': MoneyOutputToJSON(value['cpc']),
        'pnoNet': value['pnoNet'],
        'pnoGross': value['pnoGross'],
        'roasNet': value['roasNet'],
        'roasGross': value['roasGross'],
        'poasNet': value['poasNet'],
        'poasGross': value['poasGross'],
        'ctr': value['ctr'],
        'conversionRateNet': value['conversionRateNet'],
        'conversionRateGross': value['conversionRateGross'],
        'profitNet': MoneyOutputToJSON(value['profitNet']),
        'profitGross': MoneyOutputToJSON(value['profitGross']),
        'profitPercentNet': value['profitPercentNet'],
        'profitPercentGross': value['profitPercentGross'],
        'unverifiedLeads': value['unverifiedLeads'],
        'verifiedLeads': value['verifiedLeads'],
        'ordersNet': value['ordersNet'],
        'ordersGross': value['ordersGross'],
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
        'spendGoodsNet': MoneyOutputToJSON(value['spendGoodsNet']),
        'spendGoodsGross': MoneyOutputToJSON(value['spendGoodsGross']),
        'spendMarketing': MoneyOutputToJSON(value['spendMarketing']),
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'remoteId': value['remoteId'],
        'name': value['name'],
        'statusName': value['statusName'],
        'status': value['status'],
    };
}

